import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormInput from "../../../components/common/FormInput/FormInput";
import UploadImage from "../../../components/common/UploadImage/UplaodImage";
import { FaArrowLeftLong } from "react-icons/fa6";
import Button from "../../../components/common/Button/Button";
import { addProduct } from "../../../api/service/products.service";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";

const AddProductType = () => {
  const navigate = useNavigate();
  const { id: productId } = useParams();
  const [searchParams] = useSearchParams(); 

  const [formData, setFormData] = useState({
    category_id: "",
    title: "",
    sub_title: "",
    text: "",
    application_of_use: "",
    slug: "",
    image: null,
  });

  useEffect(() => {

    const id = productId || searchParams.get("category_id");
    
    if (id) {
      setFormData(prev => ({ ...prev, category_id: id }));
    } else {
      showToast.error("Category ID is missing from URL");
    }
  }, [productId, searchParams]);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (file) => {
    setFormData(prev => ({ ...prev, image: file }));
  };

  const handleSubmit = async () => {
    if (!formData.category_id) {
      showToast.error("Category ID is missing");
      return;
    }

    if (!formData.title || !formData.sub_title || !formData.text || !formData.application_of_use || !formData.image) {
      showToast.error("Please fill all required fields and upload an image");
      return;
    }

    try {
      const data = new FormData();
      data.append("category_id", formData.category_id);
      data.append("title", formData.title);
      data.append("sub_title", formData.sub_title);
      data.append("text", formData.text);
      data.append("application_of_use", formData.application_of_use);
      data.append("slug", formData.slug || formData.title.toLowerCase().replace(/\s+/g, "-"));
      data.append("image", formData.image);

      const response = await addProduct(data);

      showToast.success(response?.message || "Product added successfully!");
      navigate(-1);
    } catch (error) {
      console.error("Error adding product type:", error);
      showToast.error(error?.response?.data?.message || "Failed to add product!");
    }
  };

  return (
    <>
      <div className="d-flex align-items-center gap-3 mb-3">
        <div
          className="d-flex align-items-center gap-2"
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        >
          <FaArrowLeftLong />
          <h3 className="mb-0 management-tile ml-2">Add Product</h3>
        </div>
      </div>

      <Row className="g-3">
  
        {/* <Col xl={6} lg={6} sm={12}>
          <label className="form-label">Category ID</label>
          <FormInput
            placeholder="Category ID"
            value={formData.category_id}
            disabled
          />
        </Col> */}

        <Col xl={6} lg={6} sm={12}>
          <label className="form-label">Title *</label>
          <FormInput
            placeholder="Title"
            value={formData.title}
            onChange={(e) => handleChange("title", e.target.value)}
          />
        </Col>

        <Col xl={6} lg={6} sm={12}>
          <label className="form-label">Sub Title *</label>
          <FormInput
            placeholder="Sub Title"
            value={formData.sub_title}
            onChange={(e) => handleChange("sub_title", e.target.value)}
          />
        </Col>

        <Col xl={6} lg={6} sm={12}>
          <label className="form-label">Slug *</label>
          <FormInput
            placeholder="Slug"
            value={formData.slug}
            onChange={(e) => handleChange("slug", e.target.value)}
          />
        </Col>

        <Col xs={12}>
          <label className="form-label">Text/Description *</label>
          <FormInput
            placeholder="Enter text/description"
            type="textarea"
            value={formData.text}
            onChange={(e) => handleChange("text", e.target.value)}
          />
        </Col>

        <Col xs={12}>
          <label className="form-label">Application of Use *</label>
          <FormInput
            placeholder="Enter application of use"
            type="textarea"
            value={formData.application_of_use}
            onChange={(e) => handleChange("application_of_use", e.target.value)}
          />
        </Col>

        <Col xs={12}>
          <label className="form-label">Product Image *</label>
          <UploadImage
            onFileSelect={handleFileChange}
            multiple={false}
          />
        </Col>

        <Col xs={12} className="mt-3">
          <Button onClick={handleSubmit}>Add Product</Button>
        </Col>
      </Row>
    </>
  );
};

export default AddProductType;